<template>
    <InstreamInfo
        v-if="props.instreamData.isVisible"
        :secondsLeft="props.instreamData.secondsLeft"
        :adType="props.instreamData.adType"
        :isAdFreeActive="props.instreamData.isAdFreeActive"
        :podCounter="props.instreamData.podCounter"
    />
    <ShortGameInfo
        v-else
        :game="props.game"
        :category="props.category"
        placement="desktop_footer"
        :disabledIcon="props.disabledIcon"
        :limitedAvailability="props.limitedAvailability"
    />

    <div :class="$style.panel_spacer" />

    <div :class="$style.panel_buttons">
        <template v-if="!props.isNoAdButtonShown">
            <InstallButton
                :gamePic="props.game.icon"
                :className="$style.install_button"
            />
            <DiscordButton :className="$style.desktop_plus_only" />
            <LoginButton
                ref="login-button"
                :className="$style.desktop_plus_only"
            />
            <PartnerButton
                v-if="props.game.is_in_export_catalog && props.game.source === 'playgama'"
                :className="$style.desktop_plus_only"
                :hru="props.game.hru"
                :gameIcon="props.game.icon"
            />
            <VoteToggles
                v-if="props.game"
                :game="props.game"
            />
        </template>
        <template v-if="!props.instreamData.isVisible">
            <ShareButton
                :shareData="props.shareData"
                :gameIcon="props.game.icon"
            />
        </template>
        <Button
            v-if="props.isNoAdButtonShown"
            color="lime"
            interfaceTarget="no-ads-button"
            :label="$tr('gameContainer.noAds')"
            @click="emit('openDisabledAdModal')"
        />
        <FullscreenButton
            v-if="!props.isFullscreenButtonHidden"
            :isFullscreen="props.isFullscreen"
            @click="emit('toggleFullscreen')"
        />
    </div>
</template>

<script lang="ts" setup>
import { useTemplateRef } from 'vue'

import Button from '@/components_new/Buttons/Button.vue'
import type { APIGameType, InstreamData } from '@/types'

import InstreamInfo from '../../InstreamInfo/InstreamInfo.vue'
import ShortGameInfo from '../../ShortGameInfo.vue'
import FullscreenButton from '../FullscreenButton.vue'
import VoteToggles from '../VoteToggles.vue'
import DiscordButton from './DiscordButton.vue'
import InstallButton from './InstallButton.vue'
import LoginButton from './LoginButton.vue'
import PartnerButton from './PartnerButton.vue'
import ShareButton from './ShareButton.vue'

const props = defineProps<{
    game: APIGameType
    instreamData: InstreamData
    category: string | undefined
    isNoAdButtonShown: boolean
    isFullscreen: boolean
    shareData: ShareData
    limitedAvailability: boolean
    isFullscreenButtonHidden?: boolean
    disabledIcon?: boolean
}>()

const emit = defineEmits<{
    toggleFullscreen: []
    openDisabledAdModal: []
}>()

const loginButton = useTemplateRef('login-button')

defineExpose({
    showLoginTooltip: () => loginButton.value?.showTooltip(),
})
</script>

<style module>
.panel_spacer {
    flex-grow: 1;
    min-width: 8px;
}

.panel_buttons {
    display: flex;
    gap: 4px;
}

.desktop_plus_only {
    display: none;
}

/* Hide install button on Firefox as it doesn't support PWA installation */
@supports (-moz-appearance: none) {
    .install_button {
        display: none;
    }
}

@media (--desktop-small-plus) {
    .desktop_plus_only {
        display: block;
    }
}
</style>
